import styled from "styled-components";
import { Grid, Paper } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

import { StyledHeaderMenuButton } from "../styled";

export const StyledNotAuthMain = styled.div`
    position: relative;
    min-height: 100vh;
    background-color: var(--color-grey-400);
    @media ${breakpoints.sm} {
        background-color: var(--color-primary);
    }
`;
export const StyledNotAuthContainer = styled.div`
    display: flex;
    height: 100%;
    margin-top: 2rem;
    @media ${breakpoints.sm} {
        padding: 0 1.6rem;
    }
`;

export const StyledNotAuthContainerLeftSide = styled.div`
    position: absolute;
    top: 0;
    width: 30%;
    height: 100%;
    background-color: var(--color-primary);
    border-radius: 0 50px 50px 0;
    @media ${breakpoints.sm} {
        display: none;
    }
`;

export const StyledNotAuthContainerLeft = styled.div`
    z-index: 1;
    width: 65%;
    height: 100%;
    @media ${breakpoints.sm} {
        width: 100%;
    }
`;

export const StyledNotAuthSection = styled.div`
    display: flex;
    width: 100%;
    @media ${breakpoints.sm} {
        flex-direction: column;
    }
`;

export const StyledNotAuthSteps = styled.div`
    width: 30%;
    margin-left: 5rem;
    @media ${breakpoints.sm} {
        display: flex;
        justify-content: center;
        width: 100%;
        margin-bottom: 2rem;
        margin-left: 0;
    }
`;

export const StyledNotAuthPanel = styled.div`
    display: flex;
    justify-content: center;
    width: 70%;
    @media ${breakpoints.sm} {
        width: 100%;
    }
`;

export const StyledNotAuthPanelContainer = styled(Paper)`
    width: 504px;
    max-width: 504px;
    height: 728px;
    max-height: 650px;
    padding: 4rem 3.5rem;
    margin-bottom: 20px;
    margin-left: 20px;
    border-radius: var(--radius-10);
    @media (max-height: 930px) {
        max-height: 610px;
    }
    @media ${breakpoints.xs} {
        width: 288px;
        height: auto;
        min-height: 374px;
        max-height: 630px;
        padding: 1.6rem;
        margin-left: 0;
    }
`;

export const StyledNotAuthPanelContainerForm = styled.div`
    position: relative;
    height: 100%;

    .form-bottom-container {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
    }

    .form-bottom-container.end {
        @media ${breakpoints.xs} {
            position: relative;
            margin-top: 2.5rem;
        }
    }
`;

export const StyledNotAuthContainerRight = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35%;
    @media ${breakpoints.sm} {
        display: none;
    }

    .not-auth-top-circle {
        margin-left: -15rem;
        text-align: center;
        transform: translateY(-20%);
    }
`;

export const StyledNotAuthWrapper = styled.div`
    height: max-content;
`;

export const StyledNotAuthTitle = styled.div`
    font-size: var(--size-32);
    line-height: 61px;
    color: var(--color-primary);
    text-align: center;
`;

export const StyledNotAuthBottom = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    text-align: center;

    .not-auth-bottom-download {
        .download-title {
            margin-bottom: 10px;
            color: $colorSecondary;
        }
    }

    .not-auth-bottom-circle {
        position: absolute;
        right: 0;
        bottom: 0;
    }
`;

export const StyledLogoGridItem = styled(Grid)`
    display: flex;
    align-items: center;
    height: inherit;
`;

export const StyledMenuGridItem = styled(StyledLogoGridItem)<{
    $lightMenu: boolean;
    $lightMenuSmallInverted: boolean;
}>`
    justify-content: flex-end;
    height: 100%;

    ${StyledHeaderMenuButton} {
        ${(props) =>
            props.$lightMenu &&
            `
            color: var(--color-primary);
            .text {
                color: var(--color-primary);
            }
            .arrowIcon {
                path {
                    fill: var(--color-primary);
                }
            }
            .icon {
                svg {
                    path {
                        fill: var(--color-primary);
                    }
                }
            }
            `} @media ${breakpoints.sm} {
            ${(props) =>
                props.$lightMenuSmallInverted &&
                `
                color: var(--color-primary-fg);
                .text {
                    color: var(--color-primary-fg);
                }
                .arrowIcon {
                    path {
                        fill: var(--color-primary-fg);
                    }
                }
                .icon {
                    svg {
                        path {
                            fill: var(--color-primary-fg);
                        }
                    }
                }
                `}
        }
    }
`;
